import React from 'react'
import { Link } from 'react-router-dom'

import logo_white from '../../assets/logo_white.png'
import env from '../../assets/env.png'
import twitter from '../../assets/twitter.png'
import facebook from '../../assets/facebook.png'
import instagram from '../../assets/instagram.png'
import telegram from '../../assets/telegram.png'
import youtube from '../../assets/youtube.png'

const Footer = () => {
	return (
		<footer>
			<div className='container'>
				<div className='row'>
					<div className='col-md-5'>
						<img src={logo_white} alt='logo' className='footer_logo' />
						<p>
							Lorem Ipsum is simply dummy text of the printing and typesetting
							industry. Lorem Ipsum has been the industry's standard dummy text
							ever since the 1500s, when an unknown printer took a galley of
							type and scrambled it to make a type specimen book.
						</p>
						<form action=''>
							<label htmlFor=''> Subscribe to our newsletter:</label>
							<div className='input-group mb-3'>
								<input
									type='email'
									className='form-control footer_input'
									placeholder='Email Address'
									style={{ width: '13rem' }}
								/>
								<input
									type='number'
									className='form-control d-none'
									placeholder=''
								/>
								<button className='btn footer_btn' type='button'>
									<img src={env} alt='' />
								</button>
							</div>
						</form>
					</div>
					<div className='col-md-7'>
						<div className='row'>
							<div className='col-lg-1 col-md-1  '></div>
							<div className='col-lg-6 col-md-6 col-sm-6 col-12'>
								<h5>Quick Links</h5>
								<div className='row'>
									<div className='col-6'>
										<ul>
											<li>
												<Link to='/home' className=''>
													Home
												</Link>
											</li>
											<li>
												<Link to='/about-us' className=''>
													About
												</Link>
											</li>
											<li>
												<Link to='/professionals' className=''>
													Professionals
												</Link>
											</li>
										</ul>
									</div>
									<div className='col-6'>
										<ul>
											<li>
												<Link to='/privacy-policy' className=''>
													Privacy Policy
												</Link>
											</li>
											<li>
												<Link to='/terms' className=''>
													Terms &amp; Conditions
												</Link>
											</li>
											<li>
												<Link to='/contact' className=''>
													Contact
												</Link>
											</li>
										</ul>
									</div>
								</div>
							</div>
							<div className='col-lg-1 col-md-1 col-sm-1 col-12'></div>
							<div className='col-lg-4 col-md-4  col-sm-4 col-12'>
								<h5>Socials</h5>
								<div className='row no-gutters'>
									<div className='col-lg-3 col-md-6 col p-1'>
										<div className='footer_social'>
											<img src={twitter} alt='twitter icon' />
										</div>
									</div>
									<div className='col-lg-3 col-md-6 col p-1'>
										<div className='footer_social footer_social2'>
											<img src={facebook} alt='facebook icon' />
										</div>
									</div>
									<div className='col-lg-3 col-md-6 col p-1'>
										<div className='footer_social'>
											<img src={instagram} alt='instagram icon' />
										</div>
									</div>
									<div className='col-lg-3 col-md-6 col p-1'>
										<div className='footer_social'>
											<img src={youtube} alt='youtube icon' />
										</div>
									</div>
									{/* <div className='col-sm-4 p-1'></div> */}
									{/* <div className='col-sm-4 col p-1'>
										<div className='footer_social'>
											<img src={telegram} alt='telegram icon' />
										</div>
									</div> */}
								</div>
							</div>
						</div>
					</div>
				</div>

				<hr />
			</div>
		</footer>
	)
}

export default Footer
